import Component from './Component';
import withCreateForm from './withCreateForm';
import withUpdateForm from './withUpdateForm';

export const CreateForm = withCreateForm(Component);
export const UpdateForm = withUpdateForm(Component);



// WEBPACK FOOTER //
// ./src/compositions/CaseActivityPanel/Notes/Form/index.js